import { render, staticRenderFns } from "./report-prf-imp-business.vue?vue&type=template&id=54102700"
import script from "./report-prf-imp-business.vue?vue&type=script&lang=js"
export * from "./report-prf-imp-business.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports